import React from 'react'
import MessageUI from '../output/MessageUI'

const LabelAndValue2UI = ({messageList, labelKey, align, children}) =>
  <div className='w_lbl_val2 g_flex_h'>
    <div className={`g_muted g_small ${align==='right'?'g_text_right':''}`}>
      <MessageUI messageList={messageList} messageKey={labelKey} />
    </div>
    <div className={`${align==='right'?'g_text_right':''} g_m_left_50`}>
      {children}
    </div>
  </div>

export default LabelAndValue2UI
